import { firebaseReducer } from "react-redux-firebase";
import { routerReducer } from "react-router-redux";

import { getIsWeb } from "../lib/platformHelper";
import { reducer as modalProvider } from "../lib/react-redux-modal-provider";
import actionHandler from "./modules/actionHandler/index";
import actionInProgress from "./modules/actionInProgress/index";
import advancedChartVisible from "./modules/advancedChartVisible";
import affiliateProgram from "./modules/affiliateProgram";
import alertManagement from "./modules/alertManagement/index";
import alerts from "./modules/alerts/index";
import askFirstNamePrompt from "./modules/askFirstNamePrompt";

import analysisCategories from "./modules/analysis/analysisCategories";
import stockAnalysis from "./modules/analysis/stockAnalysis";
import auth from "./modules/auth/index";
import authLoginLoading from "./modules/authLoginLoading/index";
import autocomplete from "./modules/autocomplete/index";
import bottomNavigation from "./modules/bottomNavigation/index";
import browsedPagesCount from "./modules/browsedPagesCount";
import browserView from "./modules/browserView";
import chartAnalyses from "./modules/chartAnalyses";
import chartTemplates from "./modules/chartTemplates";
import collapsibleSections from "./modules/collapsibleSections/index";
import configPage from "./modules/configPage/index";
import contactForm from "./modules/contactForm/index";
import emailConfirmation from "./modules/emailConfirmation/index";
import expoUpdate from "./modules/expoUpdate";
import faq from "./modules/faq/index";
import followed from "./modules/followed/index";
import genericStaticPageTitle from "./modules/genericStaticPageTitle";
import globalConfig from "./modules/globalConfig";
import historyList from "./modules/historyList/index";
import homeLandingPage from "./modules/homeLandingPage/index";
import initialAuthCheck from "./modules/initialAuthCheck/index";
import instrumentsList from "./modules/instrumentsList/index";
import invoices from "./modules/invoices/index";
import lastAction from "./modules/lastAction";
import locale from "./modules/locale/index";
import manualStrategies from "./modules/manualStrategies";
import marketingBars from "./modules/marketingBars/index";
import marketingBarsSeen from "./modules/marketingBarsSeen/index";
import marketingMessages from "./modules/marketingMessages";
import member from "./modules/member/index";
import menu from "./modules/menu/index";
import navbarHeight from "./modules/navbarHeight";
import newNotifications from "./modules/newNotifications";
import notifications from "./modules/notifications/index";
import partnership from "./modules/partnership";
import partnershipTokenElementVisible from "./modules/partnershipTokenElementVisible";
import payment from "./modules/payment/index";
import paymentInvoices from "./modules/paymentInvoices/index";
import plans from "./modules/plans";
import portfolios from "./modules/portfolios/index";
import preloadedStockPageData from "./modules/preloadedStockPageData";
import priceAlerts from "./modules/priceAlerts/index";
import recommendedStocks from "./modules/recommendedStocks/index";
import reduxSagaTest from "./modules/reduxSagaTest/index";
import salesManagoEventTracker from "./modules/salesManagoEventTracker";
import screenOrientation from "./modules/screenOrientation";
import scrollToTop from "./modules/scrollToTop/index";
import search from "./modules/search/index";
import seenNotificationModal from "./modules/seenNotificationModal";
import staticPageLayout from "./modules/staticPageLayout";
import staticPageRedirects from "./modules/staticPageRedirects";
import status from "./modules/status/index";
import stockPageSections from "./modules/stockPageSections";
import stockRecommendations from "./modules/stockRecommendations";
import tags from "./modules/tags";
import tagsService from "./modules/tagsService";
import tickerAttention from "./modules/tickerAttention";
import transactionHistory from "./modules/transactionHistory/index";
import translations from "./modules/translations/index";
import tvChart from "./modules/tvchartData/index";
import universalTable from "./modules/universalTable";
import userActions from "./modules/userActions/index";
import userMarkets from "./modules/userMarkets/index";
import userMessages from "./modules/userMessages";
import insiderAnalysisCategories from "./modules/analysis/insiderAnalysisCategories";
import fullPageLoader from "./modules/fullPageLoader";
import voting from "./modules/voting";

// For the sake of readability in dev tools, please try to keep those reducers sorted alphabetically

const rehydrated = (state = false, action) => {
  switch (action.type) {
    case "persist/REHYDRATE":
      return true;
    default:
      return state;
  }
};

export default () => {
  let reducers = {
    actionHandler,
    actionInProgress,
    advancedChartVisible,
    affiliateProgram,
    alertManagement,
    alerts,
    analysisCategories,
    askFirstNamePrompt,
    auth,
    authLoginLoading,
    autocomplete,
    bottomNavigation,
    browsedPagesCount,
    browserView,
    chartAnalyses,
    chartTemplates,
    collapsibleSections,
    configPage,
    contactForm,
    emailConfirmation,
    expoUpdate,
    faq,
    firebase: firebaseReducer,
    followed,
    fullPageLoader,
    genericStaticPageTitle,
    globalConfig,
    historyList,
    homeLandingPage,
    initialAuthCheck,
    insiderAnalysisCategories,
    instrumentsList,
    invoices,
    member,
    modalProvider,
    lastAction,
    locale,
    manualStrategies,
    marketingBars,
    marketingBarsSeen,
    marketingMessages,
    menu,
    navbarHeight,
    newNotifications,
    notifications,
    partnership,
    partnershipTokenElementVisible,
    payment,
    paymentInvoices,
    portfolios,
    preloadedStockPageData,
    priceAlerts,
    recommendedStocks,
    rehydrated,
    reduxSagaTest,
    salesManagoEventTracker,
    scrollToTop,
    search,
    seenNotificationModal,
    staticPageLayout,
    staticPageRedirects,
    status,
    stockAnalysis,
    stockPageSections,
    stockRecommendations,
    tags,
    tagsService,
    tickerAttention,
    transactionHistory,
    translations,
    tvChart,
    universalTable,
    userActions,
    userMarkets,
    userMessages,
    voting,
    plans
  };

  if (getIsWeb()) {
    reducers = {
      ...reducers,
      router: routerReducer
    };
  } else {
    reducers = {
      ...reducers,
      screenOrientation
    };
  }

  return reducers;
};
